
import { useState } from 'react';

export default function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className="bg-gray-800 shadow-sm sticky top-0 z-50">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center">
              <i className="ri-truck-line text-2xl text-white"></i>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white">Man & Van Services Ltd</h1>
              <p className="text-xs text-blue-400 font-medium">Professional Moving Service</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6">
            <button
              onClick={() => scrollToSection('services')}
              className="text-white hover:text-blue-400 transition-colors cursor-pointer font-medium whitespace-nowrap text-2xl"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="text-white hover:text-blue-400 transition-colors cursor-pointer font-medium whitespace-nowrap text-2xl"
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection('fleet')}
              className="text-white hover:text-blue-400 transition-colors cursor-pointer font-medium whitespace-nowrap text-2xl"
            >
              Our Fleet
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white hover:text-blue-400 transition-colors cursor-pointer font-medium whitespace-nowrap text-2xl"
            >
              24 Hour Service
            </button>
            <a 
              href="tel:07380118450"
              className="flex items-center gap-2 text-white hover:text-blue-400 transition-colors cursor-pointer"
            >
              <i className="ri-phone-line text-blue-400 text-3xl"></i>
              <div>
                <div className="text-2xl text-gray-300">Call Us Now</div>
                <div className="text-2xl font-bold">07380 118 450</div>
              </div>
            </a>
            <a 
              href="mailto:info@manvanservices.org"
              className="flex items-center gap-2 text-white hover:text-blue-400 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line text-blue-400 text-3xl"></i>
              <div>
                <div className="text-2xl text-gray-300">Email Us</div>
                <div className="text-2xl font-bold">info@manvanservices.org</div>
              </div>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-white hover:text-blue-400 transition-colors cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-gray-700 border-t border-gray-600">
          <div className="px-4 py-6 space-y-4">
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-white hover:text-blue-400 transition-colors cursor-pointer font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="block w-full text-left text-white hover:text-blue-400 transition-colors cursor-pointer font-medium"
            >
              Pricing
            </button>
            <a 
              href="tel:07380118450"
              className="flex items-center gap-3 text-white hover:text-blue-400 transition-colors cursor-pointer"
            >
              <i className="ri-phone-line text-2xl text-blue-400"></i>
              <div>
                <div className="text-xs text-gray-300">Call Us Now</div>
                <div className="text-base font-semibold">07380 118 450</div>
              </div>
            </a>
            <a 
              href="mailto:info@manvanservices.org"
              className="flex items-center gap-3 text-white hover:text-blue-400 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line text-2xl text-blue-400"></i>
              <div>
                <div className="text-xs text-gray-300">Email Us</div>
                <div className="text-base font-semibold">info@manvanservices.org</div>
              </div>
            </a>
            <div className="flex items-center gap-3 text-white pt-2 border-t border-gray-600">
              <i className="ri-time-line text-2xl text-blue-400"></i>
              <div className="text-base font-semibold">24/7 Available</div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
